// import React, { useState } from "react";
// import { api, mediaBackendUrl } from "./localVariableFunction";

// const cardStyle = {
//   width: 200,
//   border: "1px solid #ddd",
//   borderRadius: 10,
//   margin: "8px",
//   padding: "10px",
//   boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
//   backgroundColor: "#fff",
// };

// const imgStyle = {
//   width: "100%",
//   height: 120,
//   objectFit: "cover",
//   borderRadius: 6,
//   marginBottom: 8,
// };

// const SpareCard = (props) => {
//   const imageUrl =
//     props.urlRole === "local"
//       ? props.image
//       : `${mediaBackendUrl}${props.image}`;

//   const [showDetail, setShowDetail] = useState(false);

//   const deleteSpare = async (id) => {
//     if (window.confirm("Delete this spare?")) {
//       try {
//         await api.delete(`/api/spares/${id}`);
//         alert("Deleted successfully");
//         props.refresh();
//       } catch (e) {
//         alert("Delete failed");
//       }
//     }
//   };

//   return (
//     <div style={cardStyle}>
//       {/* Image */}
//       <img src={imageUrl} alt={props.spareName} style={imgStyle} />

//       {/* Info */}
//       <p style={{ fontSize: 12, fontWeight: "bold", margin: 0 }}>
//         {props.product}
//       </p>
//       <p style={{ fontSize: 15, fontWeight: "700", margin: "4px 0" }}>
//         {props.spareName}
//       </p>
//       <p style={{ fontSize: 13, color: "#555" }}>
//         {props.description?.slice(0, 40)}...
//       </p>

//       {/* Price */}
//       <div style={{ display: "flex", gap: 6, alignItems: "center" }}>
//         <span
//           style={{ textDecoration: "line-through", color: "red", fontSize: 13 }}
//         >
//           ₹{props.actualPrice}
//         </span>
//         <span style={{ color: "green", fontWeight: "bold" }}>
//           ₹{props.offerPrice}
//         </span>
//         <span style={{ fontSize: 12, color: "blue" }}>
//           -{props.offerPercent}%
//         </span>
//       </div>
//       <p style={{ fontSize: 12, color: "#777", marginTop: 4 }}>
//         Code: {props.code} | Condition: {props.spareCondition}
//       </p>

//       {/* Actions */}
//       <div style={{ display: "flex", justifyContent: "space-between" }}>
//         {props.userRole === "admin" && (
//           <>
//             <button
//               onClick={() => deleteSpare(props.object._id)}
//               style={{ background: "red", color: "#fff", padding: "4px 8px" }}
//             >
//               Delete
//             </button>
//             <button
//               onClick={() => alert("Open Edit Modal")}
//               style={{ background: "blue", color: "#fff", padding: "4px 8px" }}
//             >
//               Edit
//             </button>
//           </>
//         )}
//         <button
//           onClick={() => setShowDetail(true)}
//           style={{ background: "#444", color: "#fff", padding: "4px 8px" }}
//         >
//           View
//         </button>
//       </div>

//       {/* Detail Modal */}
//       {showDetail && (
//         <div
//           style={{
//             position: "fixed",
//             inset: 0,
//             background: "rgba(0,0,0,0.6)",
//             display: "flex",
//             justifyContent: "center",
//             alignItems: "center",
//             zIndex: 1000,
//           }}
//         >
//           <div
//             style={{
//               width: "90%",
//               maxWidth: 500,
//               background: "#fff",
//               borderRadius: 10,
//               padding: 20,
//             }}
//           >
//             <h3>{props.spareName}</h3>
//             <img src={imageUrl} alt="big" style={{ width: "100%" }} />
//             <p>{props.description}</p>
//             <p>
//               Price: <b>₹{props.offerPrice}</b> (MRP: ₹{props.actualPrice})
//             </p>
//             <p>
//               CGST: {props.cgst}% | SGST: {props.sgst}% | HSN: {props.gstCode}
//             </p>
//             <button onClick={() => setShowDetail(false)}>Close</button>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default SpareCard;


// import React, { useState } from "react";
// import { mediaBackendUrl } from "./localVariableFunction";

// const cardStyle = {
//   width: 200,
//   border: "1px solid #ddd",
//   borderRadius: 10,
//   margin: "8px",
//   padding: "10px",
//   boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
//   backgroundColor: "#fff",
// };



// const imgStyle = {
//   width: "100%",
//   height: 120,
//   objectFit: "cover",
//   borderRadius: 6,
//   marginBottom: 8,
// };

// const SpareCard = (props) => {
//   const imageUrl =
//     props.urlRole === "local"
//       ? props.image
//       : `${mediaBackendUrl}${props.image}`;

//   const [showDetail, setShowDetail] = useState(false);

//   return (
//     <div style={cardStyle}>
//       {/* Image */}
//       <img src={imageUrl} alt={props.spareName} style={imgStyle} />

//       {/* Info */}
//       <p style={{ fontSize: 12, fontWeight: "bold", margin: 0 }}>
//         {props.product}
//       </p>
//       <p style={{ fontSize: 15, fontWeight: "700", margin: "4px 0" }}>
//         {props.spareName}
//       </p>
//       <p style={{ fontSize: 13, color: "#555" }}>
//         {props.description?.slice(0, 40)}...
//       </p>

//       {/* Price */}
//       <div style={{ display: "flex", gap: 6, alignItems: "center" }}>
//         <span
//           style={{ textDecoration: "line-through", color: "red", fontSize: 13 }}
//         >
//           ₹{props.actualPrice}
//         </span>
//         <span style={{ color: "green", fontWeight: "bold" }}>
//           ₹{props.offerPrice}
//         </span>
//         <span style={{ fontSize: 12, color: "blue" }}>
//           -{props.offerPercent}%
//         </span>
//       </div>
//       <p style={{ fontSize: 12, color: "#777", marginTop: 4 }}>
//         Code: {props.code} | Condition: {props.spareCondition}
//       </p>

//       {/* View Button */}
//       <div style={{ marginTop: 8, textAlign: "right" }}>
//         <button
//           onClick={() => setShowDetail(true)}
//           style={{
//             background: "#444",
//             color: "#fff",
//             padding: "6px 12px",
//             borderRadius: 5,
//             border: "none",
//             cursor: "pointer",
//           }}
//         >
//           View
//         </button>
//       </div>

//       {/* Detail Modal */}
//       {showDetail && (
//         <div
//           style={{
//             position: "fixed",
//             inset: 0,
//             background: "rgba(0,0,0,0.6)",
//             display: "flex",
//             justifyContent: "center",
//             alignItems: "center",
//             zIndex: 1000,
//           }}
//         >
//           <div
//             style={{
//               width: "90%",
//               maxWidth: 500,
//               background: "#fff",
//               borderRadius: 10,
//               padding: 20,
//             }}
//           >
//             <h3>{props.spareName}</h3>
//             <img src={imageUrl} alt="big" style={{ width: "100%" }} />
//             <p>{props.description}</p>

//             {/* Price Row */}
//             <p>
//               MRP:{" "}
//               <span style={{ textDecoration: "line-through", color: "red" }}>
//                 ₹{props.actualPrice}
//               </span>{" "}
//               | Offer: <b style={{ color: "green" }}>₹{props.offerPrice}</b> (
//               -{props.offerPercent}%)
//             </p>
//             <p>+ GST</p>
//             <p>
//               CGST: {props.cgst}% | SGST: {props.sgst}% | HSN: {props.gstCode}
//             </p>

//             {/* Save & Condition */}
//             <p>
//               Save: ₹{Number((props?.actualPrice || 0) - (props?.offerPrice || 0))}
//             </p>
//             <p>Condition: {props.spareCondition}</p>
//             <p>Code: {props.code}</p>

//             {/* Close Button */}
//             <button
//               onClick={() => setShowDetail(false)}
//               style={{
//                 background: "#111827",
//                 color: "#fff",
//                 padding: "6px 12px",
//                 borderRadius: 5,
//                 border: "none",
//                 cursor: "pointer",
//               }}
//             >
//               Close
//             </button>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default SpareCard;




// import React, { useState } from "react";
// import { mediaBackendUrl } from "./localVariableFunction";
// import "./SpareCard.css";

// const SpareCard = (props) => {
//   const imageUrl =
//     props.urlRole === "local"
//       ? props.image
//       : `${mediaBackendUrl}${props.image}`;

//   const [showDetail, setShowDetail] = useState(false);

//   return (
//     <div className="spare-card-col">
//       <div className="spare-card">
//         {/* Image */}
//         <img src={imageUrl} alt={props.spareName} className="spare-card-img" />

//         {/* Info */}
//         <p className="spare-card-product">{props.product}</p>
//         <p className="spare-card-name">{props.spareName}</p>
//         <p className="spare-card-desc">{props.description?.slice(0, 50)}...</p>

//         {/* Price */}
//         <div className="spare-card-price">
//           <span className="price-mrp">₹{props.actualPrice}</span>
//           <span className="price-offer">₹{props.offerPrice}</span>
//           <span className="price-percent">-{props.offerPercent}%</span>
//         </div>

//         {/* Spare Code Badge in Card */}
//         <p>
//           <span className="code-badge">{props.code}</span>
//         </p>

//         {/* Actions */}
//         <div className="spare-card-actions">
//           <button className="btn-view" onClick={() => setShowDetail(true)}>
//             View
//           </button>
//         </div>
//       </div>

//       {/* Modal */}
//       {showDetail && (
//         <div className="modal-overlay">
//           <div className="modal-box">
//             <h3>{props.spareName}</h3>
//             <img src={imageUrl} alt="big" className="modal-img" />
//             <p>{props.description}</p>

//             <p>
//               MRP: <span className="price-mrp">₹{props.actualPrice}</span> | Offer:{" "}
//               <b className="price-offer">₹{props.offerPrice}</b> (-{props.offerPercent}%)
//             </p>
//             <p>
//               CGST: {props.cgst}% | SGST: {props.sgst}% | HSN: {props.gstCode}
//             </p>
//             <p>
//               Save: ₹{Number((props?.actualPrice || 0) - (props?.offerPrice || 0))}
//             </p>
//             <p>Condition: {props.spareCondition}</p>

//             {/* Spare Code Badge inside Modal */}
//             <p>
//               Spare Code: <span className="code-badge">{props.code}</span>
//             </p>

//             <button className="btn-close" onClick={() => setShowDetail(false)}>
//               Close
//             </button>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default SpareCard;
import React, { useState } from "react";
import { mediaBackendUrl } from "./localVariableFunction";
import "./SpareCard.css";

const SpareCard = (props) => {
  const imageUrl =
    props.urlRole === "local"
      ? props.image
      : `${mediaBackendUrl}${props.image}`;

  const [showDetail, setShowDetail] = useState(false);

  return (
    <div className="spare-card-col">
      <div className="spare-card">
        {/* Image */}
        <img src={imageUrl} alt={props.spareName} className="spare-card-img" />

        {/* Info */}
        <p className="spare-card-product">{props.product}</p>
        <p className="spare-card-name">{props.spareName}</p>
        <p className="spare-card-desc">{props.description?.slice(0, 50)}...</p>

        {/* Price */}
        <div className="spare-card-price">
          <span className="price-mrp">₹{props.actualPrice}</span>
          <span className="price-offer">₹{props.offerPrice}</span>
          <span className="price-percent">-{props.offerPercent}%</span>
        </div>

        {/* Code Badge */}
        <p className="spare-card-meta">
          <span className="code-badge">Code: {props.code}</span> | Condition:{" "}
          {props.spareCondition}
        </p>

        {/* Actions */}
        <div className="spare-card-actions">
          <button className="btn-view" onClick={() => setShowDetail(true)}>
            View
          </button>
        </div>
      </div>

      {/* Modal */}
      {showDetail && (
        <div className="modal-overlay">
          <div className="modal-box">
            {/*  Close Button */}
           <button
  className="btn-close"
  onClick={() => setShowDetail(false)}
  aria-label="Close"
  title="Close"
>
 
</button>
            {/* Left Side Image */}
            <img src={imageUrl} alt="big" className="modal-img" />

            {/* Right Side Content */}
            <div className="modal-content">
              <h3>{props.spareName}</h3>
              <p>{props.description}</p>
              <p>
                MRP: <span className="price-mrp">₹{props.actualPrice}</span> |
                Offer: <b className="price-offer">₹{props.offerPrice}</b> (-
                {props.offerPercent}%)
              </p>
              <p>
                CGST: {props.cgst}
                {/* % | SGST: {props.sgst}% */}
                 {/* | HSN: {props.gstCode} */}
              </p>
              <p>
                Save: ₹
                {Number((props?.actualPrice || 0) - (props?.offerPrice || 0))}
              </p>
              <p>Condition: {props.spareCondition}</p>
              <p>
                <b>Code:</b> {props.code}
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SpareCard;
